<template>
  <div id="app">
    <div style="height: 100%">
      <router-view name="header" />
      <div>
        <router-view />
      </div>
      <router-view name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      fullWidth: document.documentElement.clientWidth,
    };
  },

  watch: {
    // '$i18n.locale'(newValue) {
    //   if (this.$i18n.locale === 'zh') {
    //     document.getElementById("app").style.fontFamily=''
    //   } else if (this.$i18n.locale === 'en') {
    //     document.getElementById("app").style.fontFamily='Manrope3 Medium'
    //      // $("#app").css(" font-family","Manrope3 Medium")
    //   }
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  mounted() {
    if (this._isMobile()) {
      window.onload = function () {
        getRem(750, 100);
      };
      window.onresize = function () {
        getRem(750, 100);
      };
      function getRem(pwidth, prem) {
        var html = document.getElementsByTagName("html")[0];
        var oWidth =
          document.body.clientWidth || document.documentElement.clientWidth;
        html.style.fontSize = (oWidth / pwidth) * prem + "px";
      }
    } else {
      window.onload = function () {
        getRem(1920, 100);
      };
      window.onresize = function () {
        getRem(1920, 100);
      };
      function getRem(pwidth, prem) {
        var html = document.getElementsByTagName("html")[0];
        var oWidth =
          document.body.clientWidth || document.documentElement.clientWidth;
        html.style.fontSize = (oWidth / pwidth) * prem + "px";
      }
    }

    // if (this._isMobile()) {
    //   this.$router.push("/m_index");

    //设置rem

    // } else {
    // }
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 14px;
  position: relative;
  height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue